import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './i18n';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { initGA4, sendToGoogleAnalytics } from './analytics/gtag';

const tapPublicKey = process.env.REACT_APP_TAP_PUBLIC_KEY;
if (tapPublicKey && typeof window !== 'undefined') {
  window.__TAP_PUBLIC_KEY__ = tapPublicKey;
}

// Inject the Google Fonts stylesheet from JS so react-snap (which prerenders
// via puppeteer 1.x) doesn't bake a render-blocking <link rel="stylesheet">
// into the static HTML. react-snap uses puppeteer 1.8 which does NOT set
// `navigator.webdriver`, so we sniff the user-agent for "HeadlessChrome"
// instead. Real users get the stylesheet injected after hydration. JS-off
// users get it via the <noscript> fallback in index.html.
if (typeof window !== 'undefined') {
  const ua = window.navigator?.userAgent || '';
  const isPrerender =
    ua.includes('ReactSnap') ||
    ua.includes('HeadlessChrome') ||
    ua.includes('Puppeteer') ||
    window.navigator?.webdriver === true ||
    window.__REACT_SNAP__ === true;
  // Tracer for debugging: writes the detection result and UA to a data
  // attribute. After build, inspect `build/index.html` to confirm
  // data-prerender="yes" (and font link is absent).
  try {
    document.documentElement.setAttribute('data-prerender', isPrerender ? 'yes' : 'no');
    document.documentElement.setAttribute('data-ua', ua.slice(0, 80));
  } catch (_) {}
  if (!isPrerender) {
    // EXPERIMENT: delay font injection until well past LCP measurement.
    // Goal: confirm whether removing font-swap completely lifts the LCP
    // score, then decide between self-hosting fonts + preload vs keeping
    // a late-load.
    const inject = () => {
      const fontHref =
        'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@400;500;600;700&family=Inter:wght@400;500;600;700&family=Outfit:wght@400;500;600;700;800&family=Instrument+Serif:ital@0;1&display=swap';
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = fontHref;
      document.head.appendChild(link);
    };
    // 6s is past Lighthouse's LCP measurement window for mobile (~5s).
    window.setTimeout(inject, 6000);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

initGA4();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendToGoogleAnalytics);
